import { flatten } from 'lodash'

export const calculateTotalPrice = (values) => {
  const isCustomPrice = Object.keys(values)
    .filter((key) => key !== 'totalPrice')
    .map((key) => values[key].costs)
    .map((cost) => cost && cost.find((item) => item.value))
    .filter((val) => val && typeof val.value === 'string')

  if (isCustomPrice[0] && isCustomPrice[0].value && typeof isCustomPrice[0].value === 'string') {
    return isCustomPrice[0].value
  } else {
    const costsSum = flatten(
      Object.keys(values)
        .filter((key) => key !== 'totalPrice')
        .map((key) => values[key].costs),
    ).reduce((prev, cur) => prev + cur.value, 0)
    const discount = Object.keys(values)
      .filter((key) => key !== 'totalPrice')
      .map((key) => values[key].discount)
      .reduce((prev, cur) => prev + cur, 0)

    const sum = costsSum - (costsSum * discount) / 100

    return sum % 1 !== 0 ? sum.toFixed(2) : sum
  }
}
